import { Component, Input, ViewChild, Output, EventEmitter, HostListener, ElementRef, AfterViewInit } from '@angular/core';

enum AuthNetEvent {
  resizeWindow = 'resizeWindow',
  successfulSave = 'successfulSave',
  cancel = 'cancel'
}

@Component({
  selector: 'app-authnet-hosted-form',
  templateUrl: './authnet-hosted-form.component.html',
  styleUrls: ['./authnet-hosted-form.component.scss']
})
export class AuthnetHostedFormComponent implements AfterViewInit {
  frameSize: IFrameDimensions = { width: 435, height: 0 };
  @Input() settings: AuthNetSettings;

  @ViewChild('form') form: ElementRef<HTMLFormElement>;

  @Output() actionComplete = new EventEmitter<AuthNetResult>();

  @HostListener('document:authNetEvent', ['$event']) onAuthNetAction(event: CustomEvent) {
    const query = event.detail;
    if (!query || typeof query !== 'string') {
      return;
    }
    const params = new URLSearchParams(query);
    const action = params.get('action');
    switch (action) {
      case AuthNetEvent.resizeWindow:
        this.frameSize = {
          width: +params.get('width') || 435,
          height: +params.get('height') || 0
        };
        break;
      case AuthNetEvent.successfulSave:
        this.actionComplete.emit('success');
        break;
      case AuthNetEvent.cancel:
        this.actionComplete.emit('cancel');
        break;
      default:
        this.actionComplete.emit('error');
        break;
    }
  }

  ngAfterViewInit() {
    this.form.nativeElement.submit();
  }
}

export interface AuthNetSettings {
  actionUrl: string;
  token: string;
  paymentProfileId?: string;
}

interface IFrameDimensions {
  width: number;
  height: number;
}

export type AuthNetResult = 'success' | 'cancel' | 'error';
